<template>
  <b-overlay
    id="overlay-background"
    class="overlay-config calendar-seasonal"
    :show="loading"
    rounded="sm"
  >
    <span
      :class="{
        'filter-kpi': true,
        hide: loading,
      }"
    >
      <label for="filter-kpi">Filtro: </label>
      <input type="text" name="filter-kpi" class="ml-1" v-model="filter" />
    </span>
    <b-list-group class="formatListProductionPlain">
      <b-list-group-item
        v-for="productionPlan of listProductionPlainItem"
        class="productPlainItem"
        :key="productionPlan.id"
        :id="productionPlan.id + '-' + productionPlan.header"
        @click="itemSelected"
        >{{ productionPlan.header }}</b-list-group-item
      >
    </b-list-group>
    <b-row class="groupBtn">
      <img
        src="@/assets/cancel.png"
        alt="limpar"
        style="margin-left: 30px;"
        title="Remover Variável PL"
        @click="clear()"
      />
      <img
        src="@/assets/salvar.png"
        alt="salvar"
        style="margin-left: 30px;"
        title="Salvar Variável PL"
        @click="salvar()"
      />
      <img
        src="@/assets/sair.png"
        style="margin-left: 30px;"
        :title="$t('cancelar')"
        alt="cancelar"
        @click="$bvModal.hide('showProductPlainItem')"
      />
    </b-row>
  </b-overlay>
</template>

<script>
import axios from "axios";
import { urlMainAPI, defaultSuccess, showError } from "../../global";
export default {
  name: "SelectProductPlainItem",
  props: ["getItemSelected"],
  data() {
    return {
      listProductionPlainItemBkp: [],
      listProductionPlainItem: [],
      productSelected: null,
      loading: false,
      filter: "",
    };
  },

  watch: {
    filter() {
      if (!this.filter)
        this.listProductionPlainItem = JSON.parse(
          JSON.stringify(this.listProductionPlainItemBkp)
        );
      else if (this.filter.length > 2)
        this.listProductionPlainItem = this.listProductionPlainItemBkp.filter(
          (p) =>
            p.header
              .toLocaleLowerCase()
              .includes(this.filter.toLocaleLowerCase())
        );
    },
  },

  methods: {
    async getProductionPlanItemList() {
      this.loading = true;
      const url = `${urlMainAPI}/getproductionplanitemlist`;
      await axios
        .get(url)
        .then((res) => {
          this.listProductionPlainItem = res.data;
          this.listProductionPlainItemBkp = JSON.parse(
            JSON.stringify(res.data)
          );
          setTimeout(() => {
            this.loadItemSelected();
          }, 100);
        })
        .catch((e) => {
          console.log(e);
          this.wait = false;
        });
      this.loading = false;
    },

    itemSelected(event) {
      document
        .querySelectorAll(".productPlainItem")
        .forEach((e) => e.classList.remove("active"));
      event.target.classList.add("active");
      this.productSelected = event.target.id;
    },

    loadItemSelected() {
      document
        .querySelectorAll(".productPlainItem")
        .forEach((e) => e.classList.remove("active"));
      this.productSelected = this.getItemSelected;
      let el = document.getElementById(`${this.productSelected}`);
      if (el) {
        el.classList.add("active");
      } else if (this.productSelected) {
        showError(this.$t('variavel-do-plano-de-safra-nao-encontrada'));
      }
    },

    salvar() {
      this.$emit("productSelected", this.productSelected);
      this.$bvModal.hide("showProductPlainItem");
      defaultSuccess(this.$t('variavel-atribuida-com-sucesso'));
    },

    clear(){
      this.$emit("productSelected", "");
      this.$bvModal.hide("showProductPlainItem");
      defaultSuccess('Variável removida!');
    },
  },
  mounted() {
    this.getProductionPlanItemList();
  },
};
</script>

<style scoped>
.formatListProductionPlain {
  height: 50vh;
  overflow-y: auto;
}

.productPlainItem {
  cursor: pointer;
}

.list-group-item.active {
  cursor: pointer;
  background-color: rgb(142, 210, 210);
  color: black;
  border: none;
}

.groupBtn {
  margin-left: 16px;
  margin-right: 16px;
}

.filter-kpi > input {
  border: 2px solid black;
  border-radius: 4px;
}
</style>
